import React from 'react'
import { Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import PedidosEgresoCalado from './PedidosEgresoCalado'

function DialogoPedidoCamiones (props) {
  const { open, handleClose } = props

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='xl'
      fullWidth
    >
      <DialogView
        cancelCallback={handleClose}
        title=''
        content={<PedidosEgresoCalado />}
      />
    </Dialog>
  )
}

export default DialogoPedidoCamiones
